module.exports = __webpack_public_path__ + "img/slide4.7672f550.png";